import type { AssistantMessage } from './types';
import { resolveInternalPath } from './resolveInternalPath';

export interface AssistantEffectPlan {
  navigateTo: string | null;
  refresh: boolean;
  seenIds: string[];
}

// Effects run only for messages the panel has not seen before, so reopening
// a conversation never replays an old navigation. Within one batch the last
// navigation wins and refresh happens once.
export function planAssistantEffects(
  messages: readonly AssistantMessage[],
  knownIds: ReadonlySet<string>,
): AssistantEffectPlan {
  let navigateTo: string | null = null;
  let refresh = false;
  const seenIds: string[] = [];
  messages.forEach((message) => {
    if (knownIds.has(message.id)) return;
    seenIds.push(message.id);
    (message.effects || []).forEach((effect) => {
      if (effect.type === 'refresh') refresh = true;
      if (effect.type === 'navigate') {
        const path = resolveInternalPath(effect.path);
        if (path) navigateTo = path;
      }
    });
  });
  return { navigateTo, refresh, seenIds };
}
